module.exports = __webpack_public_path__ + "img/Naoko_Nitta@2x.c7cbf803.png";